<!--
 * @Description: 设备统计
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-21 10:57:11
 * @LastEditTime: 2026-01-19 14:16:59
-->
<template>
<div class="AlarmStaticTotao">
  <!-- 设备统计 -->
  <div class="box">
    <div class="left" @click="handleGo('')">
      <img src="./../../assets/img/bigScreen/alarmcard.png" alt="">
      <p><span class="num">{{ (unHandle + handled) || 0 }}</span><span>报警总数</span></p>
    </div>
    <div class="progress" @click="handleGo(true)">
      <p>
        <span>已处理</span>
        <span>{{ handled }}</span>
      </p>
      <el-progress :percentage="handledRate" :show-text='false'></el-progress>
    </div>
    <div class="progress" @click="handleGo(false)">
      <p>
        <span>未处理</span>
        <span>{{ unHandle }}</span>
      </p>
      <el-progress :percentage="unHandleRate" :show-text='false'></el-progress>
    </div>
  </div>
  <div class="echarts-box">
    <div class="e">
      <echarts chart-id="MaintenanceRecord" :chart-option="options"></echarts>
    </div>
    <p>已处理统计</p>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {

  },
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'item',
          confine: true,
        },
        grid: {
          top: '8%',
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true,
        },
        radar: {
          center: ['50%', '60%'],
          radius: 55,
          indicator: [
            { name: '真实报警', max: 100 },
            { name: '测试', max: 100 },
            { name: '误报', max: 100 },
            { name: '故障', max: 100 },
            { name: '其他', max: 100 },
          ],
          axisName: { color: '#fff', fontSize: 13 },
          nameGap: 5,
          splitNumber: 5,
          axisLine: {
            lineStyle: { color: '#2D3B62' },
          },
          splitLine: { show: false },
          splitArea: {
            areaStyle: {
              color: ['#0D193A', '#192544'],
            },
          },
        },
        series: [
          {
            name: '已处理报警分类',
            type: 'radar',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 255, 246, .6)' },
                { offset: 1, color: 'rgba(1, 140, 248, .6)' },
              ]),
            },
            itemStyle: {
              color: '#00ECF6',
            },
            symbolSize: 5,
            data: [
              { value: [0, 0, 0, 0, 0] },
            ],
          },
        ],
      },
      handled: 0,
      unHandle: 0,
      handledRate: 0,
      unHandleRate: 0,
    }
  },
  computed: {
  },
  created() {
    this.getEchartsList()
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    async getEchartsList () { // 设备分类
      let { data, code } = await this.request.post('/front/alarm/record/getAlarmRecordHandleStatistics')
      // console.log(123123123123, code, data)
      if (code != 200) return
      let options = JSON.parse(JSON.stringify(this.options))
      let { falseCount, faultCount, handled, otherCount, realCount, testCount, unHandle } = data[0]
      
      let max = handled
      let indicator = options.radar.indicator.map(({ name }) => ({ name, max }))

      options.series[0].data[0].value = [realCount, testCount, falseCount, faultCount, otherCount]
      options.radar.indicator = indicator

      this.options = options


      this.handled = handled
      this.unHandle = unHandle
      this.handledRate = handled / (handled + unHandle) * 100
      this.unHandleRate = unHandle / (handled + unHandle) * 100

      this.options = options
    },
    handleGo (isHandle) {
      this.$router.push({ name: 'alarmHistory', params: { isHandle } })
    }
  },

}
</script>

<style lang="scss" scoped>
.AlarmStaticTotao {
  // font-size: 0;
  // text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  // position: relative;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  .box {
    width: 40%;
    height: 170px;
    display: inline-block;
    vertical-align: middle;
    margin: 0 10px 0 30px;
    .left {
      cursor: pointer;
      margin-bottom: 30px;
      img {
        width: 45px;
        vertical-align: middle;
      }
      p {
        width: calc(100% - 45px);
        vertical-align: middle;
        display: inline-block;
        // font-size: 12px;
        overflow: hidden;
        float: right;
        text-align: right;
        .num {
          font-size: 18px;
          color: #02D9FD;
          font-family: 'PMZD';
          margin-bottom: 6px;
        }
        span {
          display: block;
        }
      }
    }
    .progress {
      cursor: pointer;
      margin-bottom: 20px;
      p {
        margin-bottom: 6px;
        span {
          &:last-child {
            float: right;
            font-family: PMZD;
          }
        }
      }
    }
  }
  .echarts-box {
    box-sizing: border-box;
    // border: 1px solid red;
    width: calc(60% - 40px);
    height: 100%;
    display: inline-block;
    vertical-align: middle;
    .e {
      width: 100%;
      height: calc(100% - 30px);
    }
    >p {
      text-align: center;
      color: #0284D1;
    }
  }
}
</style>
<style lang="scss">
.AlarmStaticTotao {
  .el-progress-bar__inner {
    background-image: linear-gradient(90deg, #00E5FF 0%, #0284D1 100%);
  }
  .el-progress .el-progress-bar .el-progress-bar__outer .el-progress-bar__inner {
    border-radius: 10px;
  }
  .el-progress .el-progress-bar .el-progress-bar__outer {
    background: #353f56;
    border-radius: 10px;
  }
}
</style>
